import React from 'react';
import useFormHandler from 'hooks/useFormHandler';
import { Button, DynamicForm } from 'components';
import { Props } from 'types/modals';
import Base from '../../base';
import schema from './schema';

const RespondToAppealModal = ({ closing, onClose, params }: Props) => {
  const formHandler = useFormHandler({
    message: { ...schema.message }
  });

  const handleSubmit = () => {
    formHandler.setIsSubmitting(true);
    onClose(formHandler.data);
  };

  return (
    <Base
      header={`${params.type} appeal message`}
      closing={closing}
      onClose={onClose}
      size="md"
      footer={<Button text="Submit" disabled={!formHandler.valid || formHandler.isSubmitting} onClick={handleSubmit} />}
    >
      <DynamicForm handler={formHandler} />
    </Base>
  );
};

export default RespondToAppealModal;
